import { getAge } from '@/tools/getAgeFromBirthday';

const isAgePassing = ({ age_from, age_to }: any, birthday: string): boolean => {
  const childAge: number = getAge(birthday);
  return age_from <= childAge && age_to >= childAge;
};

export default isAgePassing;



// WEBPACK FOOTER //
// ./src/services/agestrict/utils/isAgePassing.ts